module.exports = __webpack_public_path__ + "static/media/hero-image-night.b8e09c35.png";